import { UseCase } from '@/core/helper/BaseUseCase';

export abstract class Command<Result = void, Param = void> extends UseCase<Result, Param> {
  readonly = true;
}
